import { styled, Badge, badgeClasses } from '@mui/material';

import AccessFeatureNextPlanChip from '../NextPlanChip';

import { AccessFeatureBadgeStyleProps } from './types';

export const AccessFeatureBadgeRoot = styled(Badge, {
  shouldForwardProp: (prop) =>
    prop !== 'fullWidth' && prop !== 'marginRightShow' && prop !== 'translateY',
})<AccessFeatureBadgeStyleProps>(
  ({ theme, fullWidth, marginRightShow, invisible, translateY }) => ({
    marginRight: 0,

    ...(fullWidth && {
      flex: 'auto',
      width: '100%',
    }),

    ...(marginRightShow &&
      invisible === false && {
        marginRight: theme.spacing(marginRightShow),
      }),

    [`& .${badgeClasses.badge}:not(.${badgeClasses.invisible})`]: {
      transform: `scale(1) translate(${theme.spacing(2.25)}, ${
        translateY ?? '-50%'
      })`,
    },
  }),
);

export const AccessFeatureBadgeNextPlanChip = styled(AccessFeatureNextPlanChip)(
  { margin: 0 },
);
